import PaymentHistory from "./PaymentHistory";

export default PaymentHistory;
